import { render } from "./ModalNewTerm.vue?vue&type=template&id=4dd228a4&scoped=true"
import script from "./ModalNewTerm.vue?vue&type=script&lang=js"
export * from "./ModalNewTerm.vue?vue&type=script&lang=js"

import "./ModalNewTerm.vue?vue&type=style&index=0&id=4dd228a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4dd228a4"

export default script